// function openTab(evt, cityName) {
//     var i, x, tablinks;
//     x = document.getElementsByClassName("tab-content");
//     for (i = 0; i < x.length; i++) {
//       x[i].style.display = "none";
//     }
//     tablinks = document.getElementsByClassName("tab-link");
//     for (i = 0; i < x.length; i++) {
//       tablinks[i].className = tablinks[i].className.replace(" tab-active", "");
//     }
//     document.getElementById(cityName).style.display = "block";
//     evt.currentTarget.className += " tab-active";
//   }

$(document).ready(function() {
  var dimensionsContents = $(".dimensions-content");

  if(dimensionsContents.length) {
    setTimeout(function() {
      $("li[data-tab-name='dimensions'] button").click();
    }, 50);

    $(".hk1").show().css("display", "flex");
  }
  
  $('[data-action="width-selector"]').each(function() {
    $(this).on('change', function(){
      var selectedValue = $(this).val(); 
      $("div.dimensions-content").hide();
      $(".hk"+selectedValue).show().css("display", "flex");
    });
  });
  
  var widthSelectors = document.querySelectorAll(".s-product__option__tab__width");
  
  widthSelectors.forEach((widthSelector, index) => {
    widthSelector.addEventListener('click', function() {
      $('#product-resources [data-action="width-selector"] ').val(index+1).trigger('change');  
    })
  })

  const accordionContainers = document.querySelectorAll('.cpts [data-accordion]');
  
  accordionContainers.forEach(container => {
    const toggles = Array.from(container.children).filter((x) => x && x.hasAttribute('[data-accordion-toggle]'.replace(']', '').replace('[', '')));
    const multiple = (container.hasAttribute('data-accordion-multiple') && (container.getAttribute('data-accordion-multiple') === 'true'));

    toggles.forEach(toggle => {
      const content = container.querySelector(`#${toggle.getAttribute('aria-controls')}`);

      if (content) {
        toggle.addEventListener('click', (event) => {
          if (toggle.getAttribute('aria-expanded') !== 'true') {
            if (!multiple) accordionCollapseAll();

            toggle.setAttribute('aria-expanded', true);
            content.removeAttribute('hidden');

          } else {
            if (!multiple) {
              accordionCollapseAll();
            } else {
              toggle.setAttribute('aria-expanded', false);
              content.setAttribute('hidden', true);
            }
          }
        });
      }
    })
  })

  const accordionCollapseAll = () => {
    accordionContainers.forEach((container) => {
      const toggles = container.querySelectorAll('[data-accordion-toggle]');

      toggles.forEach((toggle) => {
        const content = container.querySelector(`#${toggle.getAttribute('aria-controls')}`);

        if (content) {
          toggle.setAttribute('aria-expanded', false);
          content.setAttribute('hidden', true);
        }
      });
    });
  }

  const tabContainers = document.querySelectorAll('.cpts [data-tabs]');

  tabContainers.forEach(container => {
    const tabBtns = container.querySelectorAll('[data-tabs-btn]');
    
    if (tabBtns.length) {
      tabBtns.forEach((tabBtn) => {
        tabBtn.addEventListener('click', (event) => {
          const value = tabBtn.getAttribute('aria-controls');
          setActiveTab(value, tabBtns, container);
        });
      });
    }
  })

  const setActiveTab = (tabId, tabBtns, container) => {
    const tabPanels = container.querySelectorAll('[data-tabs-panel]');

    tabPanels.forEach((tabPanel) => {
      if (tabPanel.id === tabId) {
        tabPanel.removeAttribute('hidden');
      } else {
        tabPanel.setAttribute('hidden', true);
      }
    });

    tabBtns.forEach((tabBtn) => {
      if (tabBtn.getAttribute('aria-controls') === tabId) {
        tabBtn.setAttribute('aria-selected', true);
      } else {
        tabBtn.setAttribute('aria-selected', false);
      }
    });
  }

  const expandingContainer = document.querySelectorAll('[data-expanding-table]');

  expandingContainer.forEach(container => {
    const content = container.querySelector('[data-expanding-table-content]');
    const toggle = container.querySelector('[data-expanding-table-toggle]');
    const toggleText = toggle.querySelector('[data-expanding-table-toggle-text]');

    if (content && toggle) {
      toggle.addEventListener('click', (event) => {
        if (toggle.getAttribute('aria-expanded') !== 'true') {
          toggle.setAttribute('aria-expanded', true);
          toggleText.textContent = toggleText.getAttribute('data-expanding-table-toggle-text-on') || 'Less';
          container.classList.add('is-expanded');
        } else {
          toggle.setAttribute('aria-expanded', false);
          toggleText.textContent = toggleText.getAttribute('data-expanding-table-toggle-text-off') || 'More';
          container.classList.remove('is-expanded');
        }
      });
    }
  })

  // Remove all empty table + p that has only <br> as a child
  $('[data-expanding-table] .c-responsive-table table + p').each(function() {
    if ($(this).html().trim() === '<br>') {
      $(this).remove()
    }
  })

  const $parentElement = $('[data-expanding-table] .c-responsive-table')
  const $firstThreeChildren = $parentElement.children().slice(0, 3)
  const allAreTables = $firstThreeChildren.toArray().every(child => child.tagName === 'TABLE')
  const primaryParentElement = $parentElement.parents().find('[data-expanding-table]')

  if (! allAreTables) {
    primaryParentElement.addClass('richtext-also-expand')
  } else {
    // Check if tab content is table only
    const tableChild = $parentElement.children().slice(0, 1)

    if (tableChild.toArray().length > 0) {
      const firstTableChild = tableChild.toArray()[0]
      const firstTableChildTr = $(firstTableChild).find('tbody tr')

      // Hide load more button if table only and tr is <= 5
      if (firstTableChild.tagName === 'TABLE' && firstTableChildTr.length <= 5) {
        primaryParentElement.find('div:last-child').css('visibility', 'hidden')
      }
    }
  }
})